import { EventBus } from '@/main'

export default {
  methods: {
    /**
     * Open DIY Modal
     *
     * @param {Object} modalSettings Modal settings
     * @param {String} modalSettings.title Modal's title to display
     * @param {String} modalSettings.component The vue component to render
     *                                          ( without extension .vue)
     * @param {String} modalSettings.icon Font awesome icon class. Default empty.
     */
    openDIYModal(modalSettings) {
      const options = {
        title: modalSettings.title,
        icon: modalSettings.icon,
        component: modalSettings.component,
      }
      EventBus.$emit('open-diy-modal', options)
    },
  },
}
